let suppressPaletteClick = false;

export function suppressPaletteClickAfterDragDrop(): void {
  suppressPaletteClick = true;
  globalThis.setTimeout(() => {
    suppressPaletteClick = false;
  }, 0);
}

export function shouldSuppressPaletteClick(): boolean {
  return suppressPaletteClick;
}
